export default "/images/sent.png?ab066be311f885e6b7f87f76dd5aee72";